import { Anchor, Box, Container, Group, Stack, Text } from "@mantine/core";
import { IconWorld } from "@tabler/icons-react";
import { useToolkitLinks } from "../hooks/links-hook";
import { useTranslation } from "../hooks/translation-hook";
import { Language } from "../types/types";
import { SelectLanguage } from "./select-language";

export function SiteFooter({ setLanguage }: { readonly setLanguage: (language: Language) => void }): JSX.Element {
    const translate = useTranslation();
    const socialLinks = useToolkitLinks("social");
    const footerLinks = useToolkitLinks("footer");

    return (
        <Box
            component="footer"
            bg="#e9e9e9"
            py="0.9rem"
            style={{ borderTop: "1px solid #d7d7d7", borderBottom: "1px solid #d7d7d7" }}
        >
            <Container size="xl">
                <Group justify="space-between" align="flex-start" wrap="wrap" gap="lg">
                    <Stack gap={6} style={{ flex: "1 1 680px" }}>
                        <Group gap="md" wrap="wrap">
                            {socialLinks.map((link) => (
                                <Anchor
                                    key={`${link.type}-${link.name}-${link.url}`}
                                    href={link.url}
                                    c="#545454"
                                    size="sm"
                                    style={{ textDecoration: "none", fontSize: 12 }}
                                >
                                    {translate(link.name, "toolkit")}
                                </Anchor>
                            ))}
                        </Group>

                        <Group gap="xs" wrap="wrap">
                            {footerLinks.map((link, index) => (
                                <Group key={`${link.type}-${link.name}-${link.url}`} gap="xs" wrap="nowrap">
                                    <Anchor href={link.url} c="#5a5a5a" size="sm" style={{ textDecoration: "none", fontSize: 12 }}>
                                        {translate(link.name, "toolkit")}
                                    </Anchor>
                                    {index < footerLinks.length - 1 && <Text c="#8f8f8f" size="xs">|</Text>}
                                </Group>
                            ))}
                        </Group>

                        <Text c="#666" size="xs" style={{ fontSize: 12 }}>
                            Copyright © {new Date().getFullYear()} Panasonic UK & Ireland
                        </Text>
                    </Stack>

                    <Stack gap={6} align="flex-end" style={{ minWidth: 200 }}>
                        <Group gap={6} c="#5d5d5d" align="center" wrap="nowrap">
                            <IconWorld size={16} />
                            <Text size="sm" style={{ fontSize: 12 }}>
                                Area / Country
                            </Text>
                        </Group>
                        <Box w={170}>
                            <SelectLanguage setLanguage={setLanguage} />
                        </Box>
                    </Stack>
                </Group>
            </Container>
        </Box>
    );
}
